import { BorderedSection, Text } from '@capsicum/common-web';
import { type SignTypedDataProps, useSignTypedData } from '@capsicum/socios-core';
import React from 'react';
import styled from 'styled-components';

export type SignTypedDataModalProps = SignTypedDataProps;

export const SignTypedDataModal = ({
	address: _address,
	domain,
	message,
	origin,
	primaryType,
	types: _types
}: SignTypedDataModalProps) => {
	const { formatDomain, formatMessage, testIds, translations } = useSignTypedData({
		domain,
		message,
		origin,
		primaryType
	});

	return (
		<>
			<S.Title variant="title6">{translations.title}</S.Title>
			<S.SecondaryText variant="text2">{origin}</S.SecondaryText>

			{domain.name && (
				<S.StyledBorderedSection testID={testIds.domain} title={translations.domainTitle} titleInsideSection>
					<Text style={{ whiteSpace: 'pre-line' }} variant="text4">
						{formatDomain()}
					</Text>
				</S.StyledBorderedSection>
			)}

			<S.StyledBorderedSection
				testID={testIds.primaryType}
				title={translations.primaryTypeTitle}
				titleInsideSection
			>
				<Text style={{ whiteSpace: 'pre-line' }} variant="text4">
					{primaryType}
				</Text>
			</S.StyledBorderedSection>

			<S.StyledBorderedSection testID={testIds.message} title={translations.messageTitle} titleInsideSection>
				<Text style={{ whiteSpace: 'pre-line' }} variant="text4">
					{formatMessage()}
				</Text>
			</S.StyledBorderedSection>

			{domain.verifyingContract && (
				<S.StyledBorderedSection
					testID={testIds.contract}
					title={translations.smartContractTitle}
					titleInsideSection
				>
					<Text style={{ whiteSpace: 'pre-line' }} variant="text4">
						{domain.verifyingContract}
					</Text>
				</S.StyledBorderedSection>
			)}
		</>
	);
};

namespace S {
	export const Title = styled(Text)`
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;

	export const SecondaryText = styled(Text)`
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	`;

	export const StyledBorderedSection = styled(BorderedSection)`
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	`;
}
